import React from "react";

function AdminDashboard(props) {
  // Admin dashboard component
  return <div>-Add new users -View site data -View recent activity</div>;
}

export default AdminDashboard;
